import { AlertTriangle, X } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './TokenExpirationWarning.css';

const TokenExpirationWarning = () => {
  const { tokenExpiringSoon, refreshToken } = useAuth();
  const [isVisible, setIsVisible] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  if (!tokenExpiringSoon || !isVisible) {
    return null;
  }

  const handleRefreshToken = async () => {
    setIsRefreshing(true);
    try {
      await refreshToken();
      setIsVisible(false);
    } catch (error) {
      console.error('Error al renovar token:', error);
    } finally {
      setIsRefreshing(false);
    }
  };

  const handleDismiss = () => {
    setIsVisible(false);
  };

  return (
    <div className="token-expiration-warning">
      <div className="warning-content">
        <AlertTriangle size={20} className="warning-icon" />
        <div className="warning-text">
          <strong>Tu sesión expirará pronto</strong>
          <p>Para mantener tu sesión activa, haz clic en "Renovar sesión"</p>
        </div>
        <div className="warning-actions">
          <button
            className="btn btn-primary btn-small"
            onClick={handleRefreshToken}
            disabled={isRefreshing}
          >
            {isRefreshing ? 'Renovando...' : 'Renovar sesión'}
          </button>
          <button
            className="btn btn-secondary btn-small"
            onClick={handleDismiss}
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenExpirationWarning; 